import { connect } from 'react-redux';
import type { UserContext } from '@zola-helpers/client/dist/es/@types';

import { fetchModuleGroups } from 'actions/ModuleGroupActions';
import { getModuleGroups, getModuleGroupsStatus } from 'selectors/ModuleGroupSelectors';
import { getUserContext } from 'selectors/user';
import type { WModuleGroupView } from '@zola/svc-web-api-ts-client';

import NavPrimary from './NavPrimary';
import { AppDispatch, RootState } from '../../../reducers';

export type NavPrimaryMapStateProps = {
  moduleGroups: WModuleGroupView[];
  moduleGroupsBusy: boolean;
  userContext: UserContext | undefined;
};

export const mapStateToProps = (state: RootState): NavPrimaryMapStateProps => ({
  moduleGroups: getModuleGroups(state),
  moduleGroupsBusy: getModuleGroupsStatus(state),
  userContext: getUserContext(state),
});

export type NavPrimaryMapDispatchProps = {
  handleFetchModuleGroups: () => void;
};
export const mapDispatchToProps = (dispatch: AppDispatch): NavPrimaryMapDispatchProps => ({
  handleFetchModuleGroups: () => {
    dispatch(fetchModuleGroups()).catch(() => undefined);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(NavPrimary);
